export default "__VITE_ASSET__B9xsBk2u__"